import { render, staticRenderFns } from "./Osdmessage.vue?vue&type=template&id=54258886&scoped=true&"
import script from "./Osdmessage.vue?vue&type=script&lang=js&"
export * from "./Osdmessage.vue?vue&type=script&lang=js&"
import style0 from "./Osdmessage.vue?vue&type=style&index=0&id=54258886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54258886",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VBtn,VChip,VSelect})
